<template>
    <div class="create-box">
        <div class="top-box-1">
            <img class="ai-img" v-if="['chapter','baseInfo'].includes(this.activeName)" src="../../assets/image/magSys/ai.png" @click="openAiGroup" alt="">
            <route-title class="route-title" :routeArr="isEdit?['虚仿课程','编辑课程']:''"></route-title>
            <div class="content-box">
                <el-tabs :value="activeName" @tab-click="handleClick">
                    <el-tab-pane label="基本信息" name="baseInfo">
                        <base-info ref="baseInfo" :disabled="disabled" :form="form.baseInfo"></base-info>
                    </el-tab-pane>
                    <el-tab-pane label="章节目录" :disabled="!currentCourseId?true:false" name="chapter">
                        <chapter ref="chapter" v-if="activeName=='chapter'" :disabled="disabled" @add_catagory="addCategory"></chapter>
                    </el-tab-pane>
                    <el-tab-pane label="教学单元"  :disabled="!currentCourseId?true:false"  name="teachUnit">
                        <teach-unit ref="teach_unit" v-if="activeName=='teachUnit'" :disabled="disabled"></teach-unit>
                    </el-tab-pane>
                    <el-tab-pane label="试卷管理" :disabled="!currentCourseId?true:false" name="paperMag">
                        <paper-mag ref="paper_mag" disabled="disabled"></paper-mag>
                    </el-tab-pane>
                    <el-tab-pane label="教学团队" :disabled="!currentCourseId?true:false" name="teachTeam">
                        <teach-team ref="teach_team" :disabled="disabled"></teach-team>
                    </el-tab-pane>
                    <el-tab-pane label="参考教材" :disabled="!currentCourseId?true:false" name="setUp">
                        <set-up :form="form.setup" :disabled="disabled" ref="set_up"></set-up>
                    </el-tab-pane>
                </el-tabs>
            </div>
        </div>
        <group-classes ref="group_class" v-if="['chapter','baseInfo'].includes(this.activeName)"></group-classes>
    </div>
</template>

<script>
import Chapter from './createCourse/Chapter.vue'
import BaseInfo from './createCourse/BaseInfo.vue'
import SetUp from './createCourse/SetUp.vue'
import TeachUnit from './createCourse/TeachUnit.vue'
import TeachTeam from './createCourse/TeachTeam.vue';
import PaperMag from './createCourse/PaperMag.vue'
import GroupClasses from './GroupClasses.vue'
    export default {
        components:{Chapter, TeachUnit, BaseInfo, SetUp, TeachTeam, PaperMag, GroupClasses,},
        props:['disabled'],
        data(){
            return {
                form:{
                    /**章节目录数据 */
                    categoryData:[],
                    /**课程设置 */
                    setup:{
                        referenceMaterial:[],
                        examine:{
                            content:'',
                            img:''
                        }
                    }
                },
            }
        },
        methods:{
            /**打开ai组课弹窗 */
            openAiGroup(){
                var dialog=this.$refs.group_class;
                if(dialog){
                    dialog.visible=!dialog.visible;
                }
            },
            handleClick(e){
                this.$store.commit('course/changeActiveName',e.name);
                this.$nextTick(()=>{
                    if(this.activeName=='chapter'){
                        var c=this.$refs.chapter;
                        if(c){
                            c.getChapterTree();
                        }
                    }else if(this.activeName=='baseInfo'){
                        var c=this.$refs.baseInfo;
                        if(c){
                            c.courseByDetailId();
                        }
                    }else if(this.activeName=='teachUnit'){
                        var c=this.$refs['teach_unit'];
                        if(c){
                            c.getTeachingUnitList();
                        }
                    }else if(this.activeName=='teachTeam'){
                        var c=this.$refs['teach_team'];
                        if(c){
                            c.selectTeachTeam();
                        }
                    }else if(this.activeName=='paperMag'){
                        var c=this.$refs['paper_mag'];
                        if(c){
                            c.pageCourseTestPaperList();
                        }
                    }else{
                        var c=this.$refs['set_up'];
                        if(c){
                            c.selectReference();
                        }
                    }
                })
            },
            /**取消 */
            cancel(){
                this.$router.go(-1);
            },
            changeEditor(data){
                this.form.baseInfo=data;
            },
            /**递归初始化目录数据 */
            handleData(arr){
                arr.forEach(item=>{
                    item.flag=false;
                    if(item.children&&item.children.length>0){
                        this.handleData(item.children);
                    }
                })
            },
            submit(){
                var dialog=this.$refs['publish_a'];
                if(dialog){
                    dialog.dialogVisible=true;
                }
            },
            addCategory(data){
                this.form.categoryData=data;
            }
        },
        computed:{
            /**当前tab页 */
            activeName(){
                return this.$store.state.course.activeName;
            },
            /**当前课程id */
            currentCourseId(){
                return this.$store.state.course.currentCourseId||this.$route.query.id;
            },
            isEdit(){
                return this.$store.state.course.operation=='edit'||this.$route.query.operation=='edit';
            }
        },
        destroyed(){
            this.$store.commit('course/changeOperation','');
            this.$store.commit('course/changeId','');
            this.$store.commit('course/changeActiveName','baseInfo');
        }
    }
</script>

<style lang="less" scoped>
.create-box{
    background-color: #ffffff;
}
.top-box-1{
    padding:12rem var(--padding) 10rem var(--padding);
    color: #334681;
    position: relative;
    .ai-img{
        position: absolute;
        right: 0;
        top: 0;
        cursor: pointer;
        width: 16rem;
        height: auto;
        object-fit: cover;
        z-index: 9;
    }
}
.content-box{
    margin-top: 3rem;
    height: 100%;
}
/deep/.el-tabs{
    height: 100%;
}
/deep/.el-tabs__content{
    height: calc(100% - 5rem);
}
/deep/.el-tab-pane{
    height: 100%;
}
</style>